export default __webpack_public_path__ + "static/media/Post.33263c8d.jpg";